/*********************
 * Mobillor Technologies Pvt. ltd. CONFIDENTIAL
 * __________________
 *
 *  Mobillor Technologies Pvt. Ltd.
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Mobillor Technologies Pvt. Ltd.
 * The intellectual and technical concepts contained
 * herein are proprietary to Mobillor Technologies Pvt. Ltd.
 * may be covered by Rebublic Of India and Foreign Patents,
 * patents in process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Mobillor Technologies Pvt. Ltd.
 */
import { useEffect, useState } from "react";
import { connect } from "react-redux";

// Formik and Yup
import { useFormik } from "formik";
import * as Yup from "yup";

// Utils component
import TextError from "utils/TextError";

// Dashboard example components
import DataTable from "examples/Tables/DataTable";

// Dashboard components
import MDTypography from "components/MDTypography";
import MDButton from "components/MDButton";
import MDBox from "components/MDBox";
import MDCard from "components/MDCard";

// @mui material components
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Card from "@mui/material/Card";
import Modal from "@mui/material/Modal";
import IconButton from "@mui/material/IconButton";
import Tooltip from "@mui/material/Tooltip";
import Alert from "@mui/material/Alert";
import Collapse from "@mui/material/Collapse";
import Grid from "@mui/material/Grid";
import CircularProgress from "@mui/material/CircularProgress";

import { CustomToastContent } from "../../../examples/CustomToastContent/index";

// import Icon from "@mui/material/Icon";
import CloseIcon from "@mui/icons-material/Close";
import Icon from "@mui/material/Icon";

// React-Select component and styling
import Select from "react-select";

//  config file
import Config from "../../../config/index";

// Functions from store
import {
  getWarehouses,
  getRepairValue,
  getItemMaster,
  getZonesByWarehouse,
  getOpenBinsByWarehouseAndZone,
  getSubModulesByRoleId,
  getLevel1ByLevel,
  getLevel2ByLevel,
  getLevel3ByLevel,
  getLevel4ByLevel,
  getAcn,
  createRepairValue,
  uploadForRepairValue,
  getRelationLocation,
  getWarehousesByMovement,
  deleteRepairValue,
  editRepair,
  getLevelsByWarehouse,
  getDppIds,
  getDynamicColumn,
  createDynamicColumn,
} from "../../../store";

// Cookies
import Cookies from "universal-cookie";
import CreateButton from "components/standardized-components/CreateButton";
import DeleteButton from "components/standardized-components/DeleteButton";
import EditButton from "components/standardized-components/EditButton";
import { addMinutes, format } from "date-fns";
import { Backdrop } from "@mui/material";
import MDInput from "components/MDInput";
import { CSVLink } from "react-csv";
import DownloadDataButton from "components/standardized-components/DownloadDataButton";
import UploadButton from "components/standardized-components/UploadButton";
import DownloadButton from "components/standardized-components/DownloadButton";

const cookies = new Cookies();

const desLength = Config.descriptionLength;

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: { xs: 350, lg: 750 },
  height: "fit-content",
  maxHeight: "90%",
  boxShadow: 24,
  p: 0,
  pt: 2,
  overflow: "hidden",
};

const styleForEdit = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 900,
  boxShadow: 24,
  p: 1,
  pt: 3,
};

const deleteStyle = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 350,
  boxShadow: 24,
  p: 2,
  pt: 3,
};

const RepairValue = ({
  getSubModulesByRoleId,
  getSubModulesByRoleIdReducer,

  createDynamicColumn,
  getWarehouses,
  deleteRepairValue,
  warehouses,
  getRepairValue,
  getRepairValueReducer,
  getItemMaster,
  getDynamicColumn,
  itemMaster,
  getZonesByWarehouse,
  zonesByWarehouse,
  getOpenBinsByWarehouseAndZone,
  getRelationLocationReducer,
  getLevel1ByLevel,
  getWarehouseByMovementReducer,
  getLevel2ByLevel,
  getLevel3ByLevel,
  getLevel1ByLevelReducer,
  getLevel2ByLevelReducer,
  getLevel3ByLevelReducer,
  getLevel4ByLevel,
  getLevel4ByLevelReducer,
  editRepair,
  getAcn,
  getAcnReducer,
  getRelationLocation,
  createRepairValue,
  getWarehousesByMovement,
  uploadForRepairValue,
  getLevelsByWarehouse,
  levelsByWarehouseReducer,
  getDppIds,
  dppIdSelectedForGlobalFilter,

  getDynamicColumnReducer,
  getDPPReducer,
}) => {
  let loginDetails = cookies.get("loginDetailsForWMS");
  let jwtToken = loginDetails?.jwt;
  let roleId = loginDetails.data.roleId;
  let userId = loginDetails.data.userId;
  console.log(loginDetails)
  useEffect(() => {
    getSubModulesByRoleId(roleId, jwtToken);
  }, [roleId]);
  const styleForColumnReorder = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: 380,
    color: "black",
    // border: "2px solid #000",
    boxShadow: 24,
    p: 2,
    pt: 3,
  };

  const [modulesData, setModulesData] = useState([]);

  useEffect(() => {
    setModulesData(
      getSubModulesByRoleIdReducer.subModulesByRoleData.data
        ? getSubModulesByRoleIdReducer.subModulesByRoleData.data
        : []
    );
  }, [getSubModulesByRoleIdReducer]);



  let ItemLocationMapping = modulesData.find(
    (moduleId) => moduleId.moduleId == "9f3b7cf0-eb97-4567-8d4a-711868269662"
  );

  let allocateAccess = ItemLocationMapping
    ? ItemLocationMapping.actionId.includes(
      "97b863a0-4be2-489d-96f0-0ac98e8f80e0"
    )
    : null;


  let viewAccess = ItemLocationMapping
    ? ItemLocationMapping.actionId.includes(
      "a0f6b96e-282c-4349-b655-f08f172739f8"
    )
    : null;
  let editAccess = ItemLocationMapping
    ? ItemLocationMapping.actionId.includes(
      "7c85e40c-3fbd-4a3a-b86f-e9e9ac864bfc"
    )
    : null;
  let deleteAccess = ItemLocationMapping
    ? ItemLocationMapping.actionId.includes(
      "6a86c231-f828-411a-95ab-c2b144052568"
    )
    : null;

  const [pageNo, setPageNo] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(5);
  const [searchObject, setSearchObject] = useState(JSON.stringify({}));
  const [paginationObj, setPaginationObj] = useState({});
  const [errorMsgFromApi, setErrorMsgFromApi] = useState("");
  const [uncheck, setUncheck] = useState(false);

  const importPageNo = (pageIndex) => {
    setPageNo(pageIndex === -1 ? pageNo : pageIndex);
  };

  const importRowsPerPage = (pageSize) => {
    setRowsPerPage(pageSize);
  };

  const importSearch = (globalFilter) => {
    setSearchObject(globalFilter ? JSON.stringify(globalFilter) : "");
  };
  const [refresh, setRefresh] = useState("");
  // setTimeout(() => {
  //   setRefresh(!refresh);
  // }, 60000);

  const [warehouseIdSelected, setWarehouseIdSelected] = useState("");
  const [zoneIdSelected, setZoneIdSelected] = useState("");
  const [sectionIdSelected, setSectionIdSelected] = useState("");
  const [rackIdSelected, setRackIdSelected] = useState("");
  const [locationIdSelected, setLocationIdSelected] = useState("");
  const [activityIdSelected, setActivityIdSelected] = useState("");

  const handleActivityIdChange = (selectedActivity) => {
    setActivityIdSelected(selectedActivity);
    setWarehouseIdSelected("");
  };

  const handleChangeWarehouse = (selectedData) => {
    setWarehouseIdSelected(selectedData);
    setZoneIdSelected("");
    setSectionIdSelected("");
    setRackIdSelected("");
    setLocationIdSelected("");
  };

  const handleZoneIDChange = (selectedRack) => {
    setZoneIdSelected(selectedRack);
    setSectionIdSelected("");
    setRackIdSelected("");
    setLocationIdSelected("");
  };

  const handleSectionIdChange = (selectedRack) => {
    setSectionIdSelected(selectedRack);
    setRackIdSelected("");
    setLocationIdSelected("");
  };
  const handleRackIdChange = (selectedRack) => {
    setRackIdSelected(selectedRack);
    setLocationIdSelected("");
  };

  const handleLocationIdChange = (selectedLocation) => {
    setLocationIdSelected(selectedLocation);
  };

  // useEffect(() => {
  //   getRepairValue(jwtToken);
  // }, []);

  useEffect(() => {
    getDppIds(jwtToken);
  }, []);


  const [selectedZoneName, setSelectedZoneName] = useState("");

  const handleZoneNameChange = (selectedZoneName) => {
    setSelectedZoneName(selectedZoneName);
    setRackIdSelected("");
  };

  const [state, setState] = useState({
    columns: [
      { Header: "RRVL ID", accessor: "rrvId" },
      { Header: "DPP Code", accessor: "dppCode" },
      { Header: "RecyclabILity SCORE (1 to 10)", accessor: "recyclabilityScore" },
      { Header: "reuse Potential (number of cycle) ", accessor: "reusePotential" },
      { Header: "remark", accessor: "remark" },
      { Header: "rEpaired Parts value", accessor: "repairedPartsValue" },
      { Header: "Material ReCOVERY vALUE (%) ", accessor: "materialRecoveryValue" },
      {
        Header: "Assessment Date",
        accessor: "assessmentDate",
        align: "left",
        searchType: "date",
        Cell: ({ value }) => {
          return value
            ? format(new Date(value), "dd/MM/yyyy")
            : "";
        },
      },


      {
        Header: "Action",
        accessor: "action",
        cannotSearch: true,
        cannotSort: true,
      },
    ],
    rows: [],
  });
  const { columns, rows } = state;

  // const headers = [
  //   { label: "rrvId", key: "rrvId" },
  //   { label: "dppCode", key: "dppCode" },
  //   { label: "recyclabilityScore", key: "recyclabilityScore" },
  //   { label: "remark", key: "remark" },
  //   { label: "reusePotential", key: "reusePotential" },
  //   { label: "repairedPartsValue", key: "repairedPartsValue" },
  //   { label: "materialRecoveryValue", key: "materialRecoveryValue" },

  //   // Date Field
  //   { label: "assessmentDate", key: "createdDate" },

  //   // Action column (optional for CSV)
  //   // { label: "action", key: "action" }
  // ];

  // const headersForTemp = [
  //   { label: "dppCode", key: "dppCode" },
  //   { label: "recyclabilityScore", key: "recyclabilityScore" },
  //   { label: "repairedPartsValue", key: "repairedPartsValue" },
  //   { label: "materialRecoveryValue", key: "materialRecoveryValue" },
  //   { label: "assessmentDate", key: "assessmentDate" },
  //   { label: "orderNo", key: "orderNo" },
  // ];



  const headers = [
    { label: "DPP Code", key: "dppCode" },
    { label: "Recyclability Score", key: "recyclabilityScore" },
    { label: "Repaired Parts Value", key: "repairedPartsValue" },
    { label: "Material Recovery Value", key: "materialRecoveryValue" },
    { label: "Assessment Date", key: "assessmentDate" },
    { label: "Reuse Potential", key: "reusePotential" },
    { label: "Remark", key: "remark" }

    // { label: "RRV ID", key: "rrvId" }, 
  ];

  const headersForTemp = [
    { label: "dppCode", key: "dppCode" },
    { label: "recyclabilityScore", key: "recyclabilityScore" },
    { label: "repairedPartsValue", key: "repairedPartsValue" },
    { label: "materialRecoveryValue", key: "materialRecoveryValue" },
    { label: "assessmentDate", key: "assessmentDate" },
    { label: "reusePotential", key: "reusePotential" },
    { label: "remark", key: "remark" }
  ];

  const csvLink = {
    filename: "Repair Value List.csv",
    headers: headers,
    data: rows,
  };

  const csvLink2 = {
    filename: "Repair Value Template.csv",
    headers: headersForTemp,
    data: [],
  };

  const [activityOptions, setActivityOptions] = useState([]);

  const [loading, setLoading] = useState(true);
  useEffect(() => {
    let tempMappedActivity = [];
    let data = getRepairValueReducer.repairValue.data
      ? getRepairValueReducer.repairValue.data
      : [];
    console.log(data);
    // setPaginationObj(getRepairValueReducer?.repair?.pagination);
    setLoading(getRepairValueReducer.loading);

    data.map((item) => {
      const formatDate = new Date(item.assessmentDate);
      let itemDescription = item.itemDescription;
      let len = desLength;

      const itemObject = {
        privateKey: item.itemCode,
        itemCodeDes: `${item.itemCode} / ${itemDescription ? itemDescription.substring(0, len) : ""
          }`,
        rrvId: item.rrvId,
        dppCode: item.dppCode,
        assessmentDate: item.assessmentDate,
        recyclabilityScore: item.recyclabilityScore,
        reusePotential: item.reusePotential,
        remark: item.remark,
        repairedPartsValue: item.repairedPartsValue,
        materialRecoveryValue: item.materialRecoveryValue,
        itemCode: item.itemCode,

        itemDescription: (
          <span style={{ display: "flex", alignItems: "center" }}>
            {item?.itemDescription?.length > 35 ? (
              <Tooltip
                title={item.itemDescription}
                style={{ cursor: "pointer" }}
              >
                <MDTypography
                  variant="h6"
                  fontWeight="regular"
                  style={{ fontSize: "14px" }}
                >
                  {item.itemDescription.substring(0, len)}
                </MDTypography>
              </Tooltip>
            ) : (
              <MDTypography
                variant="h6"
                fontWeight="regular"
                style={{ fontSize: "14px" }}
              >
                {item.itemDescription}
              </MDTypography>
            )}
            {item?.itemDescription?.length > 35 && (
              <span style={{ marginLeft: "0.1rem" }}>...</span>
            )}
          </span>
        ),

        id: item.id,
        categoryCode: item.categoryCode,
        warehouse: item.warehouseCode,
        zone: item.zone,
        section: item.section,
        createdDate: format(new Date(formatDate), "dd/MM/yyyy"),
        cd: item.cd,
        rack: item.rack,
        location: item.location,
        // itemName: des ? des.substring(0, len) : "",
        acnCode: item.acnCode,
        action: (
          <>
            {deleteAccess && (
              <DeleteButton
                tooltip="Delete"
                variant="gradient"
                color="error"
                iconOnly
                type="button"
                style={{ marginRight: "5px" }}
                onClick={() => handleOpenDeleteModal(item)}
              >
                <Icon>delete</Icon>
              </DeleteButton>
            )}
            {editAccess && (
              <EditButton
                tooltip="Edit"
                variant="gradient"
                color="success"
                iconOnly
                type="button"
                onClick={() => {
                  handleOpenUpdateModal(item);
                }}
                style={{ marginRight: "5px" }}
              >
                <Icon>edit_sharp</Icon>
              </EditButton>
            )}
          </>
        ),
      };
      tempMappedActivity.push(itemObject);
    });

    viewAccess && setState({ ...state, rows: tempMappedActivity });
  }, [getRepairValueReducer]);

  useEffect(() => {
    let tempActivityOptions = [];
    let data = getAcnReducer.acn.data ? getAcnReducer.acn.data : [];
    data.map((activity) => {
      tempActivityOptions.push({
        label: activity.acnName,
        value: activity.acnId,
      });
    });
    setActivityOptions(tempActivityOptions);
  }, [getAcnReducer]);

  const [warehouseOptions, setWarehouseOptions] = useState([]);
  useEffect(() => {
    let tempWarehouseOptions = [];
    let data = warehouses.warehouses ? warehouses.warehouses : [];
    data.map((warehouse) => {
      tempWarehouseOptions.push({
        label: warehouse.warehouseCode,
        value: warehouse.warehouseId,
      });
    });
    setWarehouseOptions(tempWarehouseOptions);
  }, [warehouses]);

  const [warehouseOptionsByMovement, setWarehouseOptionsByMovement] = useState(
    []
  );

  useEffect(() => {
    let tempWarehouseOptions = [];
    let data = getWarehouseByMovementReducer.warehouses.data
      ? getWarehouseByMovementReducer.warehouses.data
      : [];
    data.map((warehouse) => {
      tempWarehouseOptions.push({
        label: warehouse.warehouseCode,
        value: warehouse.warehouseId,
      });
    });
    setWarehouseOptionsByMovement(tempWarehouseOptions);
  }, [getWarehouseByMovementReducer]);
  // useEffect(() => {
  //   let tempLevelOptions = [];
  //   let data = getRelationLocationReducer.locations.data
  //     ? getRelationLocationReducer.locations.data
  //     : [];

  //   data.map((level) => {
  //     tempLevelOptions.push({
  //       label: level.rltName,
  //       value: level.rltLevel,
  //     });
  //   });
  //   setLevelOptions(tempLevelOptions);
  // }, [getRelationLocationReducer]);

  // let level1Name = getRelationLocationReducer.locations.data

  const [itemCodeOptions, setItemCodeOptions] = useState([]);

  useEffect(() => {
    let tempItemCodeOptions = [];
    let data = itemMaster.itemMaster.data ? itemMaster.itemMaster.data : [];
    data.map((item) => {
      let des = item?.itemDescription;
      let len = desLength;
      tempItemCodeOptions.push({
        label: `${item.itemCode} / ${des ? des.substring(0, len) : ""}`,
        value: item.itemId,
      });
    });
    setItemCodeOptions(tempItemCodeOptions);
  }, [itemMaster]);

  const [zoneOptions, setZoneOptions] = useState([]);

  useEffect(() => {
    let tempZonesByWarehouse = [];
    let data = zonesByWarehouse.zones.data ? zonesByWarehouse.zones.data : [];
    data.map((zone) => {
      tempZonesByWarehouse.push({
        label: zone.zoneName,
        value: zone.id,
      });
    });
    setZoneOptions(tempZonesByWarehouse);
  }, [zonesByWarehouse]);

  // useEffect(() => {
  //   getLevelsByWarehouse(warehouseIdSelected?.value, jwtToken);
  // }, [warehouseIdSelected]);

  const [levelOptions, setLevelOptions] = useState([]);

  useEffect(() => {
    let tempLevelOptions = [];
    let data = levelsByWarehouseReducer.levelsByWarehouse.data
      ? levelsByWarehouseReducer.levelsByWarehouse.data
      : [];

    data.map((level) => {
      tempLevelOptions.push({
        label: level?.rltName,
        value: level?.rltLevel,
      });
    });
    setLevelOptions(tempLevelOptions);
  }, [levelsByWarehouseReducer]);

  const [level1Options, setLevel1Options] = useState([]);

  useEffect(() => {
    let tempLevelOptions = [];
    let data = getLevel1ByLevelReducer.level1ByLevel.data
      ? getLevel1ByLevelReducer.level1ByLevel.data
      : [];
    data.map((level) => {
      tempLevelOptions.push({
        label: level.locationName,
        value: level.locationId,
      });
    });

    setLevel1Options(tempLevelOptions);
  }, [getLevel1ByLevelReducer]);

  const [level2Options, setLevel2Options] = useState([]);

  useEffect(() => {
    let tempLevelOptions = [];
    let data = getLevel2ByLevelReducer.level2ByLevel.data
      ? getLevel2ByLevelReducer.level2ByLevel.data
      : [];
    data.map((level) => {
      tempLevelOptions.push({
        label: level.locationName,
        value: level.locationId,
      });
    });

    setLevel2Options(tempLevelOptions);
  }, [getLevel2ByLevelReducer]);

  const [level3Options, setLevel3Options] = useState([]);

  useEffect(() => {
    let tempLevelOptions = [];
    let data = getLevel3ByLevelReducer.level3ByLevel.data
      ? getLevel3ByLevelReducer.level3ByLevel.data
      : [];

    data.map((level) => {
      tempLevelOptions.push({
        label: level.locationName,
        value: level.locationId,
      });
    });

    setLevel3Options(tempLevelOptions);
  }, [getLevel3ByLevelReducer]);

  const [level4Options, setLevel4Options] = useState([]);

  useEffect(() => {
    let tempLevelOptions = [];
    let data = getLevel4ByLevelReducer.level4ByLevel.data
      ? getLevel4ByLevelReducer.level4ByLevel.data
      : [];

    data.map((level) => {
      tempLevelOptions.push({
        label: level.locationName,
        value: level.locationId,
      });
    });

    setLevel4Options(tempLevelOptions);
  }, [getLevel4ByLevelReducer]);

  const [openBinsOptions, setOpenBinsOptions] = useState([]);
  const [isSuccessAllocateItem, setIsSuccessAllocateItem] = useState(false);
  const [isErrorAllocateItem, setIsErrorAllocateItem] = useState(false);

  useEffect(() => {
    if (isSuccessAllocateItem) {
      setTimeout(() => {
        setIsSuccessAllocateItem(false);
      }, 3000);
    }
  }, [isSuccessAllocateItem]);

  useEffect(() => {
    if (isErrorAllocateItem) {
      setTimeout(() => {
        setIsErrorAllocateItem(false);
      }, 3000);
    }
  }, [isErrorAllocateItem]);

  const [dppIdSelected, setdppIdSelected] = useState("");
  const [allocateItemModal, setAllocateItemModal] = useState(false);
  const handleAllocateItemModal = () => {
    setAllocateItemModal(!allocateItemModal);
    formik.setErrors({});
    setZoneIdSelected("");

    setWarehouseIdSelected("");
    setSectionIdSelected("");
    setRackIdSelected("");
    setLocationIdSelected("");
  };
  const handleCloseAllocateItemModal = (event, reason) => {
    if (reason === "backdropClick")
      return;
    setAllocateItemModal(!allocateItemModal);

    formik.setValues(initialValues);

    setdppIdSelected("");
    formik.setErrors({});
    setWarehouseIdSelected("");
    setLocationIdSelected("");
    setActivityIdSelected("");
    setSelectedItemCode("");
  };

  const [ActivityMappingData, setActivityMappingData] = useState({});

  const [selectedItemCode, setSelectedItemCode] = useState("");

  const handleItemCodeChange = (selectedItemCode) => {
    setSelectedItemCode(selectedItemCode);
  };

  const [selectedBin, setSelectedBin] = useState("");

  const handleBinChange = (selectedBin) => {
    setSelectedBin(selectedBin);
  };
  const [selectedBinForAdd, setSelectedBinForAdd] = useState("");

  const handleBinChangeForAdd = (selectedBinForAdd) => {
    setSelectedBinForAdd(selectedBinForAdd);
  };

  const [selectedOpenBin, setSelectedOpenBin] = useState(
    ActivityMappingData?.locationName
  );

  useEffect(() => {
    if (ActivityMappingData) {
      setSelectedOpenBin({
        label: ActivityMappingData?.locationName,
        value: ActivityMappingData?.locationName,
      });
    }
  }, [ActivityMappingData]);

  const handleOpenBinChange = (selectedOpenBin) => {
    setSelectedOpenBin(selectedOpenBin);
  };


  // dppId: values.DPPID,
  // recyclabilityScore: values.RecylabilityScore,
  // repairedPartsValue: values.RepairedPartsValue,
  // materialRecoveryValue: values.MaterialRecoveryValue,
  // assessmentDate: values.AssesmentDate,



  const initialValues = {
    DPPID: "",
    RecylabilityScore: "",
    RepairedPartsValue: "",
    MaterialRecoveryValue: "",
    AssesmentDate: "",

  };

  const validationSchema = Yup.object({
    //  DPPID: Yup.object()
    //     .required("Select DPP Code"),

    RecylabilityScore: Yup.string()
      .required(" ")
      // .matches(/^[0-9]+$/, "Only digits allowed")
      .max(3, "Value cannot exceed 100"), // optional but helpful

    RepairedPartsValue: Yup.string()
      .required(" "),
    // .matches(/^[0-9]+$/, "Only digits allowed"),

    MaterialRecoveryValue: Yup.string()
      .required(" "),
    // .matches(/^[0-9]+$/, "Only digits allowed"),

    AssesmentDate: Yup.date()
      .required(" ")
      .typeError("Assessment Date must be a valid date"),
  });


  const [errorMsg, setErrorMsg] = useState("");

  const [allocateButtonName, setAllocateButtonName] = useState("Create");

  const onSubmit = async (values, { resetForm }) => {
    setAllocateButtonName("Please wait...");
    const payload = {
      // warehouseId: warehouseIdSelected?.value,
      // itemId: selectedItemCode.value,
      // zoneId: zoneIdSelected.value,
      // sectionId: sectionIdSelected.value,
      // rackId: rackIdSelected.value,
      // locationId: locationIdSelected.value,
      // acnId: activityIdSelected.value,
      cdBy: userId,
      dppId: dppIdSelected?.value,
      recyclabilityScore: values.RecylabilityScore,
      repairedPartsValue: values.RepairedPartsValue,
      materialRecoveryValue: values.MaterialRecoveryValue,
      reusePotential: values.ReusePotential,
      remark: values.Remark,
      assessmentDate: values.AssesmentDate,
    };

    let res = await createRepairValue(payload, jwtToken);
    if (res.status) {
      setIsSuccessAllocateItem(true);
      // getOpenBinsByWarehouseAndZone(warehouseIdSelected?.value, zoneIdSelected);
      getRepairValue(dppIdSelectedForGlobalFilter?.value, jwtToken);
      formik.setErrors({});
      setActivityIdSelected("");
      setWarehouseIdSelected("");
      setZoneIdSelected("");
      setSectionIdSelected("");
      setRackIdSelected("");
      setLocationIdSelected("");
      setTimeout(() => {
        setAllocateButtonName("create");
        handleCloseAllocateItemModal();
      }, 2250);
    }
    if (!res.status) {
      setErrorMsg(res?.data?.data?.msg);
      setAllocateButtonName("create");
      setIsErrorAllocateItem(true);
    }
    setSelectedItemCode("");
    setSelectedZoneName("");
    setSelectedBin("");
    // resetForm();
  };

  const [singleDataForDelete, setSingleDataForDelete] = useState({});
  const [openDeleteModal, setOpenDeleteModal] = useState(false);

  const handleOpenDeleteModal = (data) => {
    setOpenDeleteModal(true);
    setSingleDataForDelete(data);
  };

  const handleCloseDeleteModal = () => {
    setOpenDeleteModal(false);
  };


  const handleChangeDpp = (selectedData) => {
    setdppIdSelected(selectedData);

  };


  useEffect(() => {
    if (dppIdSelectedForGlobalFilter) {
      setdppIdSelected(dppIdSelectedForGlobalFilter);
    }
  }, [dppIdSelectedForGlobalFilter]);



  useEffect(() => {
    if (dppIdSelectedForGlobalFilter?.value) {
      // Fetch with dppId + jwtToken
      getRepairValue(dppIdSelectedForGlobalFilter?.value, jwtToken);
    } else {
      // Fetch without filter
      getRepairValue(null, jwtToken);
    }
  }, [dppIdSelectedForGlobalFilter, jwtToken]);

  const [dppOptions, setDPPOptions] = useState([]);

  useEffect(() => {
    let tempgetDPPReducer = [];
    let data = getDPPReducer.dpp.data ? getDPPReducer.dpp.data : [];
    data.map((zone) => {
      tempgetDPPReducer.push({
        label: zone.dppCode,
        value: zone.dppId,
      });
    });
    setDPPOptions(tempgetDPPReducer);
  }, [getDPPReducer]);

  const [isErrorDeleteAssembly, setIsErrorDeleteAssembly] = useState(false);
  const [errorMsgForDelete, setErrorMsgForDelete] = useState(false);
  const [isSuccessForAssembly, setIsSuccessForAssembly] = useState(false);

  useEffect(() => {
    if (isErrorDeleteAssembly) {
      setTimeout(() => {
        setIsErrorDeleteAssembly(false);
      }, 3000);
    }
  }, [isErrorDeleteAssembly]);
  useEffect(() => {
    if (isSuccessForAssembly) {
      setTimeout(() => {
        setIsSuccessForAssembly(false);
      }, 2000);
    }
  }, [isSuccessForAssembly]);

  const [deleteButtonName, setDeleteButtonName] = useState("Delete");

  const deleteTripNo = async () => {
    setDeleteButtonName("Please wait...");
    let rrvId = singleDataForDelete.rrvId;
    // let udBy = singleDataForDelete.udBy;
    // let userId = singleDataForDelete.userId;

    let res = await deleteRepairValue(rrvId, userId, jwtToken);

    if (res.status) {
      getRepairValue(dppIdSelectedForGlobalFilter?.value, jwtToken);
      setTimeout(() => {
        handleCloseDeleteModal();
        setDeleteButtonName("Delete");
      }, 3000);
      setIsSuccessForAssembly(true);
    }

    if (!res.status) {
      setIsErrorDeleteAssembly(true);
      setErrorMsgForDelete(res?.data?.data?.msg);
      setDeleteButtonName("Delete");
    }
  };

  const formik = useFormik({
    initialValues,
    onSubmit,
    validationSchema,
  });

  const [isSuccessAddActivityMapping, setIsSuccessAddActivityMapping] =
    useState(false);
  const [isErrorAddActivityMapping, setIsErrorAddActivityMapping] =
    useState(false);

  useEffect(() => {
    if (isSuccessAddActivityMapping) {
      setTimeout(() => {
        setIsSuccessAddActivityMapping(false);
      }, 3000);
    }
  }, [isSuccessAddActivityMapping]);

  useEffect(() => {
    if (isErrorAddActivityMapping) {
      setTimeout(() => {
        setIsErrorAddActivityMapping(false);
      }, 3000);
    }
  }, [isErrorAddActivityMapping]);

  const [addActivityMappingModal, setAddActivityMappingModal] = useState(false);
  const handleAddActivityMappingModal = () => {
    setAddActivityMappingModal(!addActivityMappingModal);
    formikForAdd.setErrors({});
  };
  const handleCloseAddActivityMappingModal = () => {
    setAddActivityMappingModal(!addActivityMappingModal);
    formikForAdd.setErrors({});
  };

  const initialValueForAddActivityMapping = {
    bin: "",
  };

  const validationSchemaForAddActivityMapping = Yup.object({
    bin: Yup.string().required("Select the BIN"),
  });

  const onSubmitForAddActivityMapping = async (values, { resetForm }) => {
    const payload = {
      warehouseId: warehouseIdSelected?.value,
      itemId: ActivityMappingData.itemId,
      zoneId: ActivityMappingData.zoneId,
      locationId: selectedBinForAdd.value,
    };

    setSelectedBinForAdd("");
    resetForm();
  };

  const formikForAdd = useFormik({
    initialValues: initialValueForAddActivityMapping,
    validationSchema: validationSchemaForAddActivityMapping,
    onSubmit: onSubmitForAddActivityMapping,
  });

  const [isSuccessEditActivityMapping, setIsSuccessEditActivityMapping] =
    useState(false);
  const [isErrorEditActivityMapping, setIsErrorEditActivityMapping] =
    useState(false);

  useEffect(() => {
    if (isSuccessEditActivityMapping) {
      setTimeout(() => {
        setIsSuccessEditActivityMapping(false);
      }, 3000);
    }
  }, [isSuccessEditActivityMapping]);

  useEffect(() => {
    if (isErrorEditActivityMapping) {
      setTimeout(() => {
        setIsErrorEditActivityMapping(false);
      }, 3000);
    }
  }, [isErrorEditActivityMapping]);

  const [editActivityMappingModal, setEditActivityMappingModal] =
    useState(false);
  const handleEditActivityMappingModal = () => {
    setEditActivityMappingModal(!editActivityMappingModal);
    formikForEdit.setErrors({});
  };

  const handleCloseEditActivityMappingModal = () => {
    setEditActivityMappingModal(!editActivityMappingModal);
    formikForEdit.setErrors({});
  };
  const initialValueForEditActivityMapping = {
    bin: "",
  };

  const validationSchemaForEditActivityMapping = Yup.object({
    bin: Yup.string().required("Select the BIN"),
  });

  const onSubmitForEditActivityMapping = async (values, reset) => {
    const payload = {
      itemId: ActivityMappingData.itemId,
      warehouseId: warehouseIdSelected?.value,
      zoneId: ActivityMappingData.zoneId,
      locationId: selectedOpenBin?.value,
    };

    // let res = await editBinAllocation(payload, jwtToken);

    // if (res.status) {
    //   setIsSuccessEditActivityMapping(true);
    //   getRepairValue(warehouseIdSelected?.value, jwtToken);
    // }
    // if (!res.status) {
    //   setIsErrorEditActivityMapping(true);
    // }
    // setSelectedOpenBin("");
  };
  const formikForEdit = useFormik({
    initialValues: initialValueForEditActivityMapping,
    validationSchema: validationSchemaForEditActivityMapping,
    onSubmit: onSubmitForEditActivityMapping,
    enableReinitialize: true,
  });

  const [warehouseTypesSelectedForEdit, setWarehouseTypesSelectedForEdit] =
    useState("");
  const [itemCodeSelectedForEdit, setItemCodeSelectedForEdit] = useState("");
  const [acnTypeSelectedForEdit, setAcnTypeSelectedForEdit] = useState("");
  const [zoneSelectedForEdit, setZoneSelectedForEdit] = useState("");
  const [sectionSelectedForEdit, setSectionSelectedForEdit] = useState("");
  const [rackSelectedForEdit, setRackSelectedForEdit] = useState("");
  const [locationSelectedForEdit, setLocationSelectedForEdit] = useState("");

  const [singleFgDataForUpdate, setSingleFgDataForUpdate] = useState({});
  const [openUpdateModal, setOpenUpdateModal] = useState(false);

  const handleOpenUpdateModal = (singleData) => {

    setSingleFgDataForUpdate(singleData);
    setOpenUpdateModal(true);

    // getWarehousesByMovement(
    //   acnTypeSelectedForEdit?.value,

    //   jwtToken
    // );
  };

  const handleChangeWarehouseForEdit = (selectedOption) => {
    setWarehouseTypesSelectedForEdit(selectedOption);
    setZoneSelectedForEdit("");
  };
  const handleChangeAcnForEdit = (selectedOption) => {
    setAcnTypeSelectedForEdit(selectedOption);
  };
  const handleChangeZoneForEdit = (selectedOption) => {
    setZoneSelectedForEdit(selectedOption);
    setSectionSelectedForEdit("");
  };
  const handleChangeSectionForEdit = (selectedOption) => {
    setSectionSelectedForEdit(selectedOption);
    setRackSelectedForEdit("");
  };
  const handleChangeRackForEdit = (selectedOption) => {
    setRackSelectedForEdit(selectedOption);
    setLocationSelectedForEdit("");
  };
  const handleChangeLocationForEdit = (selectedOption) => {
    setLocationSelectedForEdit(selectedOption);
  };


  // dppId: values.DPPID,
  // recyclabilityScore: values.RecylabilityScore,
  // repairedPartsValue: values.RepairedPartsValue,
  // materialRecoveryValue: values.MaterialRecoveryValue,

  const initialValueForUpdate = {
    AssesmentDate: singleFgDataForUpdate.assessmentDate
      ? (() => {
        const [month, day, year] =
          singleFgDataForUpdate.assessmentDate.split("/");
        return `${year}-${month}-${day}`;
      })()
      : "",

    DPPID: singleFgDataForUpdate.dppCode,
    RecylabilityScore: singleFgDataForUpdate.recyclabilityScore,
    ReusePotential: singleFgDataForUpdate.reusePotential,
    Remark: singleFgDataForUpdate.remark,
    RepairedPartsValue: singleFgDataForUpdate.repairedPartsValue,
    MaterialRecoveryValue: singleFgDataForUpdate.materialRecoveryValue,

  };

  const handleCloseModal = (event, reason) => {
    if (reason === "backdropClick")
      return;
    setOpenUpdateModal(false);
    formikForUpdate.setErrors({});
    formikForUpdate.setValues(initialValueForUpdate);
  };
  const [isErrorForUpdate, setIsErrorForUpdate] = useState(false);
  const [isSuccessForUpdate, setIsSuccessForUpdate] = useState(false);
  const [errorMsgForUpdate, setErrorMsgForUpdate] = useState("");

  useEffect(() => {
    if (isErrorForUpdate) {
      setTimeout(() => {
        setIsErrorForUpdate(false);
      }, 3000);
    }
  }, [isErrorForUpdate]);

  useEffect(() => {
    if (isSuccessForUpdate) {
      setTimeout(() => {
        setIsSuccessForUpdate(false);
      }, 3000);
    }
  }, [isSuccessForUpdate]);

  const [editButtonName, setEditButtonName] = useState("Update");

  const onSubmitForUpdate = async (values) => {
    setEditButtonName("Please wait...");
    let payload = {
      udBy: userId,
      // dppId: values.DPPID,
      rrvId: singleFgDataForUpdate.rrvId,

      recyclabilityScore: String(values.RecylabilityScore ?? ""),
      repairedPartsValue: String(values.RepairedPartsValue ?? ""),
      materialRecoveryValue: String(values.MaterialRecoveryValue ?? ""),
      reusePotential: Number(values.ReusePotential ?? ""),
      remark: String(values.Remark ?? ""),


      assessmentDate: values.AssesmentDate,
    };
    let res = await editRepair(payload, jwtToken);
    if (res.status) {
      setIsSuccessForUpdate(true);
      getRepairValue(dppIdSelectedForGlobalFilter?.value, jwtToken);
      setTimeout(() => {
        handleCloseModal();
        setEditButtonName("Update");
      }, 3000);
    }
    if (!res.status) {
      setIsErrorForUpdate(true);
      setErrorMsgForUpdate(res?.data?.data?.msg);
      setEditButtonName("Update");
    }
  };

  const formikForUpdate = useFormik({
    initialValues: initialValueForUpdate,
    onSubmit: onSubmitForUpdate,
    // validationSchema: validationSchemaForAssembly,
    enableReinitialize: true,
  });
  const [isErrorDeleteActivityMapping, setIsErrorDeleteActivityMapping] =
    useState(false);
  useEffect(() => {
    if (isErrorDeleteActivityMapping) {
      setTimeout(() => {
        setIsErrorDeleteActivityMapping(false);
      }, 3000);
    }
  }, [isErrorDeleteActivityMapping]);

  const [openDeleteActivityMappingModal, setOpenDeleteActivityMappingModal] =
    useState(false);

  const handleOpenDeleteActivityMappingModal = (data = {}) => {
    setActivityMappingData(data);
    setOpenDeleteActivityMappingModal(true);
  };

  const handleCloseDeleteActivityMappingModal = () => {
    setOpenDeleteActivityMappingModal(false);
  };

  const [deleteErrorMsg, setDeleteErrorMsg] = useState("");
  // const [editButtonName, setEditButtonName] = useState("Submit");

  const onClickDeleteActivityMapping = async () => {
    // let res = await removeBinAllocation(
    //   warehouseIdSelected?.value,
    //   ActivityMappingData.itemId,
    //   ActivityMappingData.zoneId,
    //   ActivityMappingData.locationId,
    //   jwtToken
    // );
    // if (res.status) {
    //   getRepairValue(warehouseIdSelected?.value, jwtToken);
    //   setOpenDeleteActivityMappingModal(false);
    // }
    // if (!res.status) {
    //   setDeleteErrorMsg(res.data.response.data.msg);
    //   setIsErrorDeleteActivityMapping(true);
    // }
  };

  const DataUploadSuccessNotification = () =>
    toast.success("Data Uploaded Successfully", {
      position: "top-center",
      autoClose: 2000,
    });

  const DataUploadFailureNotification = (data) =>
    toast.error(data, {
      position: "top-center",
      autoClose: 2000,
    });

  const [uploadCsvFilter, setUploadCsvFilter] = useState(false);
  const data = getRelationLocationReducer.locations?.data || [];
  const uploadCsvFilterHandler = () => {
    setUploadCsvFilter(!uploadCsvFilter);
  };
  const [uploadCsvData, setUploadCsvData] = useState({});
 

  const uploadCsvHandler = async () => {
    if (!uploadCsvData) {
      toast.error("Please select a CSV file first!");
      return;
    }

    let formData = new FormData();
    formData.append("file", uploadCsvData);

    try {
      let res = await uploadForRepairValue(formData, jwtToken);

      if (res?.status === true || res?.data?.status === true) {
        getRepairValue(dppIdSelectedForGlobalFilter?.value, jwtToken);
        setUploadCsvFilter(false);
      }
      showUploadNotification(res);

    } catch (error) {
      showUploadNotification(error);
    }
  };


  const showUploadNotification = (res) => {
    const payload = res?.response?.data || res?.data?.data || res?.data || res || {};

    const isSuccess = payload.status === true;
    const msg = payload.msg;
    const description = payload.description;

    const counts = {
      success: payload.successCount,
      error: payload.errorCount,
      duplicate: payload.duplicateCount
    };

    const toastOptions = {
      position: "top-center",
      autoClose: 5000,
      closeOnClick: false,
      draggable: true,
    };

    if (isSuccess) {
      toast.success(
        <CustomToastContent msg={msg} description={description} counts={counts} isSuccess={true} />,
        toastOptions
      );
    } else {
      toast.error(
        <CustomToastContent msg={msg} description={description} counts={counts} isSuccess={false} />,
        toastOptions
      );
    }
  };

  const subModuleId = "9f3b7cf0-eb97-4567-8d4a-711868269662";
  let dynamicColumnDetails = cookies.get("dynamic-column-data");
  // let userId = loginDetails.data.userId;
  let hiddenColumsDetails = cookies.get("hidden-column-data");
  useEffect(() => {
    getDynamicColumn(userId, subModuleId, jwtToken);
  }, [userId, subModuleId]);
  const [loadingForDynamicColumn, setLoadingForDynamicColumn] = useState(false);
  useEffect(() => {
    let data = getDynamicColumnReducer.dynamicColumn.data
      ? getDynamicColumnReducer.dynamicColumn.data
      : [];

    setDynamicColumnData(data);
    cookies.set("hidden-column-data", JSON.stringify(data?.notVisibleFields), {
      path: "/",
    });

    setTimeout(() => {
      setLoadingForDynamicColumn(true);
    }, 1000);
  }, [getDynamicColumnReducer, loading]);

  const [openCreateColumnReorderModal, setOpenCreateColumnReorderModal] =
    useState(false);

  const handleOpenCreateColumnReorderModal = () => {
    setOpenCreateColumnReorderModal(true);
  };

  const handleCloseCreateColumnReorderModal = () => {
    setOpenCreateColumnReorderModal(false);
  };

  const [dynamicColumnData, setDynamicColumnData] = useState("");
  const [isErrorColumnReorder, setIsErrorColumnReorder] = useState(false);
  const [isSuccessColumnReorder, setIsSuccessColumnReorder] = useState(false);

  useEffect(() => {
    if (isErrorColumnReorder) {
      setTimeout(() => {
        setIsErrorColumnReorder(false);
      }, 3000);
    }
  }, [isErrorColumnReorder]);

  useEffect(() => {
    if (isSuccessColumnReorder) {
      setTimeout(() => {
        setIsSuccessColumnReorder(false);
      }, 3000);
    }
  }, [isSuccessColumnReorder]);

  const [isErrorMsgForColumnReorder, setIsErrorMsgForColumnReorder] =
    useState(false);

  const handleDynamicColumn = async () => {
    let res = await createDynamicColumn(dynamicColumnDetails, jwtToken);
    if (res.status) {
      setIsSuccessColumnReorder(true);
      getDynamicColumn(userId, subModuleId, jwtToken);
      getRepairValue(dppIdSelectedForGlobalFilter?.value, jwtToken);
      setTimeout(() => {
        handleCloseCreateColumnReorderModal();
        // window.location.reload();
      }, 2250);
    }
    if (!res.status) {
      setIsErrorColumnReorder(true);
      setIsErrorMsgForColumnReorder(res?.data?.data?.msg);
    }
  };

  return (
    // <DashboardLayout>
    //   <DashboardNavbar />
    <div>
      <MDBox pt={0} pb={0} mb={-2.5}>
        <Grid container spacing={6}>
          <Grid item xs={12}>
            <MDBox
              display="flex"
              justifyContent="space-between"
              alignItems="center"
              p={0}
              mb={-4.5}
              mt={-1}
            >
              <MDBox color="text" px={2} ml={-2} mb={4}>
                {allocateAccess && (
                  <Tooltip>
                    <CreateButton
                      tooltip="Add Repair Value"
                      color="info"
                      variant="contained"
                      type="button"
                      iconOnly
                      onClick={(event) => {
                        handleAllocateItemModal();
                        getWarehouses(jwtToken);
                        getItemMaster(jwtToken);
                        getAcn(jwtToken);
                        getRelationLocation(jwtToken);
                      }}
                      style={{ borderRadius: "5px" }}
                      size="small"
                    >
                      <Icon>add</Icon>
                    </CreateButton>
                  </Tooltip>
                )}
                <CSVLink {...csvLink}  >
                  <DownloadDataButton
                    tooltip="Download Repair Value List"
                    style={{ marginLeft: "1rem" }}
                    type="button"
                    variant="outlined"
                    color="error"
                    iconOnly
                  >
                    <Icon>download</Icon>
                  </DownloadDataButton>
                </CSVLink>

                {
                  //  uploadFG && 
                  (
                    <UploadButton
                      tooltip="Upload CSV"
                      //   disabled={!uploadItem}
                      style={{ marginLeft: "1rem" }}
                      type="button"
                      variant="outlined"
                      color="info"
                      iconOnly
                      onClick={uploadCsvFilterHandler}
                    >
                      <Icon>upload</Icon>
                    </UploadButton>
                  )}

                <CSVLink {...csvLink2}>
                  <DownloadButton
                    tooltip="Download Template"
                    style={{ marginLeft: "1rem" }}
                    type="button"
                    variant="outlined"
                    color="error"
                    iconOnly
                  >
                    <Icon>download</Icon>
                  </DownloadButton>
                </CSVLink>
                {/* <Tooltip title="Upload CSV">
                    <MDButton
                      style={{ marginLeft: "1rem" }}
                      // disabled={!uploadItem}
                      type="button"
                      variant="outlined"
                      color="info"
                      iconOnly
                      onClick={uploadCsvFilterHandler}
                    >
                      <Icon>upload</Icon>
                    </MDButton>
                  </Tooltip> */}
              </MDBox>
            </MDBox>

            {uploadCsvFilter && (
              <div style={{ marginLeft: "1", marginTop: "0.5rem" }}>
                <div>
                  <input
                    className="choose_file"
                    style={{
                      marginTop: "1.5rem",
                      marginLeft: "1.5rem",
                      // marginBottom: "-9rem",
                    }}
                    type="file"
                    accept=".csv"
                    onChange={(e) => {
                      setUploadCsvData(e.target.files[0]);
                    }}
                  />
                  <MDButton
                    disabled={
                      !uploadCsvData?.name || uploadCsvData?.type !== "text/csv"
                    }
                    variant="contained"
                    color="info"
                    style={{
                      marginLeft: { xs: "1.5rem", lg: "1" },
                      marginTop: "0rem",
                    }}
                    type="button"
                    onClick={uploadCsvHandler}
                  >
                    UPLOAD
                  </MDButton>
                </div>
                <div style={{ marginBottom: "-20px" }}>
                  <span
                    style={{
                      color: "red",
                      fontSize: "14px",
                      marginLeft: "30px",
                      fontStyle: "italic",
                    }}
                  >
                    <strong>*</strong> Please upload
                    <strong>".csv"</strong> file only
                  </span>
                </div>
              </div>
            )}
            <Modal
              open={openCreateColumnReorderModal}
              onClose={handleCloseCreateColumnReorderModal}
              aria-labelledby="modal-modal-title"
              aria-describedby="modal-modal-description"
            >
              <MDCard sx={styleForColumnReorder}>
                <MDTypography>Are you sure you want to submit?</MDTypography>
                <MDBox mt={2}>
                  <MDButton
                    style={{ width: "10rem", marginRight: "0.5rem" }}
                    color="info"
                    variant="outlined"
                    onClick={handleCloseCreateColumnReorderModal}
                  >
                    Cancel
                  </MDButton>
                  <MDButton
                    style={{ width: "10rem", marginLeft: "0.5rem" }}
                    color="success"
                    onClick={handleDynamicColumn}
                  // disabled={denyButtonName === "Please wait..."}
                  >
                    Submit
                  </MDButton>
                </MDBox>
                <MDBox mt={2}>
                  <Collapse in={isSuccessColumnReorder}>
                    <Alert
                      severity="success"
                      action={
                        <IconButton
                          aria-label="close"
                          color="inherit"
                          size="small"
                          onClick={() => {
                            setIsSuccessColumnReorder(false);
                          }}
                        >
                          <CloseIcon fontSize="inherit" />
                        </IconButton>
                      }
                    >
                      Data updated successfully!
                    </Alert>
                  </Collapse>
                  <Collapse in={isErrorColumnReorder}>
                    <Alert
                      severity="error"
                      action={
                        <IconButton
                          aria-label="close"
                          color="inherit"
                          size="small"
                          onClick={() => {
                            setIsErrorColumnReorder(false);
                          }}
                        >
                          <CloseIcon fontSize="inherit" />
                        </IconButton>
                      }
                    >
                      {isErrorMsgForColumnReorder}
                    </Alert>
                  </Collapse>
                </MDBox>
              </MDCard>
            </Modal>

            <MDBox pt={0}>
              {loadingForDynamicColumn && (
                <DataTable
                  table={{ columns, rows }}
                  isSorted={true}
                  tableSearch={true}
                  entriesPerPage={{
                    defaultValue: 5,
                    entries: [5, 10, 15, 20, 25, 30],
                  }}
                  showTotalEntries={true}
                  noEndBorder
                  options={{ draggable: false }}
                  // serverSidePagination={true}
                  // paginationObj={paginationObj}
                  // pageNoValue={pageNo}
                  // rowsPerPageValue={rowsPerPage}
                  // pageNoProp={importPageNo}
                  // rowsPerPageProp={importRowsPerPage}
                  // searchProp={importSearch}
                  loading={loading}
                  hideColumns={hiddenColumsDetails}
                  visibleColumns2={dynamicColumnData?.visibleFields}
                  dynamicColumnData={dynamicColumnData}
                  handleOpenCreateColumnReorderModal={
                    handleOpenCreateColumnReorderModal
                  }
                  subModuleId={subModuleId}
                  userId={userId}
                />
              )}
            </MDBox>
            <Modal
              open={openDeleteModal}
              onClose={handleCloseDeleteModal}
              aria-labelledby="modal-modal-title"
              aria-describedby="modal-modal-description"
            >
              <MDCard sx={deleteStyle}>
                <MDTypography>Are you sure you want to delete?</MDTypography>
                <MDBox mt={2}>
                  <MDButton
                    color="info"
                    variant="outlined"
                    onClick={handleCloseDeleteModal}
                  >
                    Cancel
                  </MDButton>
                  <MDButton
                    style={{ marginLeft: "0.5rem" }}
                    color="error"
                    onClick={deleteTripNo}
                    disabled={deleteButtonName === "Please wait..."}
                  >
                    {deleteButtonName}
                  </MDButton>
                  <MDBox mt={2}>
                    <Collapse in={isErrorDeleteAssembly}>
                      <Alert
                        severity="error"
                        action={
                          <IconButton
                            aria-label="close"
                            color="inherit"
                            size="small"
                            onClick={() => {
                              setIsErrorDeleteAssembly(false);
                            }}
                          >
                            <CloseIcon fontSize="inherit" />
                          </IconButton>
                        }
                      >
                        {errorMsgForDelete}
                      </Alert>
                    </Collapse>
                    <Collapse in={isSuccessForAssembly}>
                      <Alert
                        severity="success"
                        action={
                          <IconButton
                            aria-label="close"
                            color="inherit"
                            size="small"
                            onClick={() => {
                              setIsSuccessForAssembly(false);
                            }}
                          >
                            <CloseIcon fontSize="inherit" />
                          </IconButton>
                        }
                      >
                        Deleted Successfully
                      </Alert>
                    </Collapse>
                  </MDBox>
                </MDBox>
              </MDCard>
            </Modal>
            <Modal
              open={openUpdateModal}
              onClose={handleCloseModal}
              aria-labelledby="modal-modal-title"
              aria-describedby="modal-modal-description"
            >
              <MDCard sx={styleForEdit}>
                <MDBox ml={3} mt={-2} display="flex" alignItems="center">
                  <MDTypography variant="h4" fontWeight="medium" flexGrow={1}>
                    Update
                  </MDTypography>
                  <MDBox>
                    <Tooltip title="Close">
                      <IconButton
                        aria-label="close"
                        color="inherit"
                        onClick={handleCloseModal}
                        style={{
                          background: "whitesmoke",
                          color: "black",
                          borderRadius: 5,
                          marginRight: "10px",
                          marginTop: "4px",
                        }}
                      >
                        <CloseIcon />
                      </IconButton>
                    </Tooltip>
                  </MDBox>
                </MDBox>
                <hr style={{ marginTop: "0.5rem", marginBottom: "1rem" }} />

                <MDBox pt={1} pb={3} px={3}>
                  <MDBox
                    component="form"
                    role="form"
                    onSubmit={formikForUpdate.handleSubmit}
                  >
                    <MDBox>
                      <Grid container spacing={1}>
                        <Grid item xs={12} lg={6}>
                          <MDBox ml={1}>
                            <MDTypography variant="h6">DPP Code</MDTypography>
                            <MDInput
                              type="text"
                              name="DPPID"
                              fullWidth
                              autoComplete="off"
                              onBlur={formikForUpdate.handleBlur}
                              onChange={formikForUpdate.handleChange}
                              value={formikForUpdate.values.DPPID}
                              error={
                                formikForUpdate.touched.DPPID &&
                                formikForUpdate.errors.DPPID &&
                                true
                              }
                              disabled={true}
                              inputProps={{
                                style: {
                                  height: "10px",
                                },
                                maxLength: 45,
                              }}
                            />
                            {formikForUpdate.touched.DPPID &&
                              formikForUpdate.errors.DPPID && (
                                <TextError msg={formikForUpdate.errors.DPPID} />
                              )}
                          </MDBox>
                        </Grid>
                        <Grid item xs={12} lg={6}>
                          <MDBox ml={1}>
                            <MDTypography variant="h6">
                              Recylability Score(1 to 10)
                            </MDTypography>
                            <MDInput
                              type="text"
                              name="RecylabilityScore"
                              fullWidth
                              autoComplete="off"
                              onBlur={formikForUpdate.handleBlur}
                              onChange={formikForUpdate.handleChange}
                              value={formikForUpdate.values.RecylabilityScore}
                              error={
                                formikForUpdate.touched.RecylabilityScore &&
                                formikForUpdate.errors.RecylabilityScore &&
                                true
                              }
                              inputProps={{
                                style: {
                                  height: "10px",
                                },
                                maxLength: 45,
                              }}
                            />
                            {formikForUpdate.touched.RecylabilityScore &&
                              formikForUpdate.errors.RecylabilityScore && (
                                <TextError
                                  msg={formikForUpdate.errors.RecylabilityScore}
                                />
                              )}
                          </MDBox>
                        </Grid>
                        <Grid item xs={12} lg={6}>
                          <MDBox ml={1}>
                            <MDTypography variant="h6">
                              Repaired Parts Value
                            </MDTypography>
                            <MDInput
                              type="text"
                              name="RepairedPartsValue"
                              fullWidth
                              autoComplete="off"
                              onBlur={formikForUpdate.handleBlur}
                              onChange={formikForUpdate.handleChange}
                              value={formikForUpdate.values.RepairedPartsValue}
                              error={
                                formikForUpdate.touched.RepairedPartsValue &&
                                formikForUpdate.errors.RepairedPartsValue &&
                                true
                              }
                              inputProps={{
                                style: {
                                  height: "10px",
                                },
                                maxLength: 45,
                              }}
                            />
                            {formikForUpdate.touched.RepairedPartsValue &&
                              formikForUpdate.errors.RepairedPartsValue && (
                                <TextError
                                  msg={
                                    formikForUpdate.errors.RepairedPartsValue
                                  }
                                />
                              )}
                          </MDBox>
                        </Grid>
                        <Grid item xs={12} lg={6}>
                          <MDBox ml={1}>
                            <MDTypography variant="h6">
                              Material Recovery Value(%)
                            </MDTypography>
                            <MDInput
                              type="text"
                              name="MaterialRecoveryValue"
                              fullWidth
                              autoComplete="off"
                              onBlur={formikForUpdate.handleBlur}
                              onChange={formikForUpdate.handleChange}
                              value={
                                formikForUpdate.values.MaterialRecoveryValue
                              }
                              error={
                                formikForUpdate.touched.MaterialRecoveryValue &&
                                formikForUpdate.errors.MaterialRecoveryValue &&
                                true
                              }
                              inputProps={{
                                style: {
                                  height: "10px",
                                },
                                maxLength: 45,
                              }}
                            />
                            {formikForUpdate.touched.MaterialRecoveryValue &&
                              formikForUpdate.errors.MaterialRecoveryValue && (
                                <TextError
                                  msg={
                                    formikForUpdate.errors.MaterialRecoveryValue
                                  }
                                />
                              )}
                          </MDBox>
                        </Grid>
                        <Grid item xs={12} lg={6}>
                          <MDBox >
                            <MDTypography variant="h6">
                              Reuse Potential(number of cycle)
                            </MDTypography>
                            <MDInput
                              type="number"

                              placeholder="Enter number"
                              name="ReusePotential"
                              fullWidth
                              autoComplete="off"
                              onBlur={formikForUpdate.handleBlur}
                              onChange={formikForUpdate.handleChange}
                              value={formikForUpdate.values.ReusePotential}
                              error={
                                formikForUpdate.touched.ReusePotential &&
                                formikForUpdate.errors.ReusePotential &&
                                true
                              }
                              inputProps={{
                                style: {
                                  height: "10px",
                                },
                                maxLength: 45,
                              }}
                            />
                            {formikForUpdate.touched.ReusePotential &&
                              formikForUpdate.errors.ReusePotential && (
                                <TextError
                                  msg={formikForUpdate.errors.ReusePotential}
                                />
                              )}
                          </MDBox>
                        </Grid>
                        <Grid item xs={12} lg={6}>
                          <MDBox ml={1}>
                            <MDTypography variant="h6">
                              Remark
                            </MDTypography>
                            <MDInput
                              type="text"

                              placeholder="Enter Remarks"
                              name="Remark"
                              fullWidth
                              autoComplete="off"
                              onBlur={formikForUpdate.handleBlur}
                              onChange={formikForUpdate.handleChange}
                              value={formikForUpdate.values.Remark}
                              error={
                                formikForUpdate.touched.Remark &&
                                formikForUpdate.errors.Remark &&
                                true
                              }
                              inputProps={{
                                style: {
                                  height: "10px",
                                },
                                maxLength: 45,
                              }}
                            />
                            {formikForUpdate.touched.Remark &&
                              formikForUpdate.errors.Remark && (
                                <TextError
                                  msg={formikForUpdate.errors.Remark}
                                />
                              )}
                          </MDBox>
                        </Grid>
                        <Grid item xs={12} lg={12}>
                          <MDBox ml={1} mb={1}>
                            <MDTypography variant="h6">
                              Assesment Date
                            </MDTypography>
                            <MDInput
                              type="date"
                              name="AssesmentDate"
                              fullWidth
                              autoComplete="off"
                              onBlur={formikForUpdate.handleBlur}
                              onChange={formikForUpdate.handleChange}
                              value={formikForUpdate.values.AssesmentDate}
                              error={
                                formikForUpdate.touched.AssesmentDate &&
                                formikForUpdate.errors.AssesmentDate &&
                                true
                              }
                              inputProps={{
                                style: {
                                  height: "10px",
                                },
                                maxLength: 45,
                              }}
                            />
                            {formikForUpdate.touched.AssesmentDate &&
                              formikForUpdate.errors.AssesmentDate && (
                                <TextError
                                  msg={formikForUpdate.errors.AssesmentDate}
                                />
                              )}
                          </MDBox>
                        </Grid>
                        {/* <Grid item xs={12} lg={6}>
                              <MDBox ml={1}>
                                            <MDTypography variant="h6">Collection Program</MDTypography>
                                            <MDInput
                                              type="text"
                                              name="serialNumber"
                                              fullWidth
                                              autoComplete="off"
                                              onBlur={formikForUpdate.handleBlur}
                                              onChange={formik.handleChange}
                                              value={formik.values.serialNumber}
                                              error={
                                                formik.touched.serialNumber &&
                                                formik.errors.serialNumber &&
                                                true
                                              }
                                              inputProps={{
                                                style: {
                                                  height: "10px",
                                                },
                                                maxLength: 45,
                                              }}
                                            />
                                            {formik.touched.serialNumber &&
                                              formik.errors.serialNumber && (
                                                <TextError msg={formik.errors.serialNumber} />
                                              )}
                                          </MDBox>
                      </Grid>
                            <Grid item xs={12} lg={6}>
                              <MDBox ml ={1} mb={1} >
                                            <MDTypography variant="h6">Audit Date</MDTypography>
                                            <MDInput
                                              type="date"
                                              name="serialNumber"
                                              fullWidth
                                              autoComplete="off"
                                              onBlur={formik.handleBlur}
                                              onChange={formik.handleChange}
                                              value={formik.values.serialNumber}
                                              error={
                                                formik.touched.serialNumber &&
                                                formik.errors.serialNumber &&
                                                true
                                              }
                                              inputProps={{
                                                style: {
                                                  height: "10px",
                                                },
                                                maxLength: 45,
                                              }}
                                            />
                                            {formik.touched.serialNumber &&
                                              formik.errors.serialNumber && (
                                                <TextError msg={formik.errors.serialNumber} />
                                              )}
                                          </MDBox>
                      </Grid>
                      */}
                        {/* <Grid item xs={12} lg={6}>
                          <MDBox mb={2} ml={1} >
                            <MDTypography
                              variant="h6"
                              style={{ fontWeight: 500 }}
                            >
                              Status
                            </MDTypography>
                            <Select
                              isClearable
                              className="select-css"
                              maxMenuHeight={70}
                              placeholder="Select..."
                              name="location"
                              options={level4Options}
                              value={locationSelectedForEdit} // Ensure this matches the shape of options
                              onChange={(selectedOption) => {
                                handleChangeLocationForEdit(selectedOption);
                                formikForUpdate.setFieldValue(
                                  "location",
                                  selectedOption
                                );
                              }}
                            />
                            {formikForUpdate.touched.location &&
                              formikForUpdate.errors.location && (
                                <TextError
                                  msg={formikForUpdate.errors.location}
                                />
                              )}
                          </MDBox>
                        </Grid> */}

                        <Grid item xs={12} >
                          <MDBox>
                            <Collapse in={isErrorForUpdate}>
                              <Alert
                                severity="error"
                                action={
                                  <IconButton
                                    aria-label="close"
                                    color="inherit"
                                    size="small"
                                    onClick={() => {
                                      setIsErrorForUpdate(false);
                                    }}
                                  >
                                    <CloseIcon fontSize="inherit" />
                                  </IconButton>
                                }
                              >
                                {errorMsgForUpdate}
                              </Alert>
                            </Collapse>
                            <Collapse in={isSuccessForUpdate}>
                              <Alert
                                severity="success"
                                action={
                                  <IconButton
                                    aria-label="close"
                                    color="inherit"
                                    size="small"
                                    onClick={() => {
                                      setIsSuccessForUpdate(false);
                                    }}
                                  >
                                    <CloseIcon fontSize="inherit" />
                                  </IconButton>
                                }
                              >
                                Updated successfully
                              </Alert>
                            </Collapse>
                          </MDBox>
                        </Grid>
                        {/* <MDBox mt={3} ml={10}> */}

                        {/* <MDButton
                          // variant="contained"
                          color="success"
                          fullWidth
                          type="submit"
                          disabled={editButtonName === "Please wait..."}
                        >
                          {editButtonName}
                        </MDButton> */}

                        {/* Submit Button */}
                        <MDButton
                          color="info"
                          fullWidth
                          type="submit"
                          disabled={editButtonName === "Please wait..."}
                        >
                          {editButtonName}
                        </MDButton>
                      </Grid>
                    </MDBox>
                  </MDBox>
                </MDBox>
              </MDCard>
            </Modal>
            <Modal
              open={allocateItemModal}
              onClose={handleCloseAllocateItemModal}
              aria-labelledby="modal-modal-title"
              aria-describedby="modal-modal-description"
            >
              <MDCard sx={style}>
                <MDBox ml={3} mt={-1} display="flex" alignItems="center">
                  <MDTypography variant="h5" fontWeight="medium" flexGrow={1}>
                    Create Repair & Recycle Assessment
                  </MDTypography>
                  <MDBox>
                    <span>
                      <Tooltip title="Close">
                        <IconButton
                          style={{
                            background: "whitesmoke",
                            color: "black",
                            borderRadius: 5, marginRight: "10px",
                            marginTop: "3px",
                          }}
                          aria-label="close"
                          color="inherit"
                          onClick={handleCloseAllocateItemModal}
                        >
                          <CloseIcon />
                        </IconButton>
                      </Tooltip>
                    </span>
                  </MDBox>
                </MDBox>
                <hr style={{ marginTop: "0.5rem", marginBottom: "1rem" }} />

                <MDBox pt={1} pb={3} px={3}>
                  <MDBox
                    component="form"
                    role="form"
                    onSubmit={formik.handleSubmit}
                  >
                    <Grid container>
                      <Grid item xs={12} lg={6}>
                        <MDBox mb={1} >
                          <MDTypography
                            variant="h6"
                            style={{ fontWeight: "500" }}
                          >
                            {" "}
                            DPP Code{" "}
                          </MDTypography>

                          <Select
                            // isDisabled={activityIdSelected ? false : true}
                            isClearable
                            className="select-css"
                            maxMenuHeight={200}
                            placeholder="Choose one..."
                            name="DPPID"
                            onBlur={() => {
                              formik.handleBlur({
                                target: { name: "DPPID" },
                              });
                            }}
                            value={dppIdSelected}
                            options={dppOptions}
                            onChange={(selectedOption) => {
                              handleChangeDpp(selectedOption);
                              // getZonesByWarehouse(selectedOption?.value);
                              formik.setFieldValue(
                                "DPPID",
                                selectedOption
                              );

                            }}
                          />
                          {formik.touched.DPPID &&
                            formik.errors.DPPID && (
                              <TextError msg={formik.errors.DPPID} />
                            )}
                        </MDBox>
                      </Grid>
                      <Grid item xs={12} lg={6}>
                        <MDBox ml={1}>
                          <MDTypography variant="h6">
                            Recylability Score(1 to 10)
                          </MDTypography>
                          <MDInput
                            type="text"

                            placeholder="Enter number"
                            name="RecylabilityScore"
                            fullWidth
                            autoComplete="off"
                            onBlur={formik.handleBlur}
                            onChange={formik.handleChange}
                            value={formik.values.RecylabilityScore}
                            error={
                              formik.touched.RecylabilityScore &&
                              formik.errors.RecylabilityScore &&
                              true
                            }
                            inputProps={{
                              style: {
                                height: "10px",
                              },
                              maxLength: 45,
                            }}
                          />
                          {formik.touched.RecylabilityScore &&
                            formik.errors.RecylabilityScore && (
                              <TextError
                                msg={formik.errors.RecylabilityScore}
                              />
                            )}
                        </MDBox>
                      </Grid>

                      <Grid item xs={12} lg={6}>
                        <MDBox mb={2}>
                          <MDTypography variant="h6">
                            Repaired Parts Value
                          </MDTypography>
                          <MDInput
                            type="text"

                            placeholder="Enter number"
                            name="RepairedPartsValue"
                            fullWidth

                            autoComplete="off"
                            onBlur={formik.handleBlur}
                            onChange={formik.handleChange}
                            value={formik.values.RepairedPartsValue}
                            error={
                              formik.touched.RepairedPartsValue &&
                              formik.errors.RepairedPartsValue &&
                              true
                            }
                            inputProps={{
                              style: {
                                height: "10px",
                              },
                              maxLength: 45,
                            }}
                          />
                          {formik.touched.RepairedPartsValue &&
                            formik.errors.RepairedPartsValue && (
                              <TextError
                                msg={formik.errors.RepairedPartsValue}
                              />
                            )}
                        </MDBox>
                      </Grid>
                      <Grid item xs={12} lg={6}>
                        <MDBox ml={1}>
                          <MDTypography variant="h6">
                            Material Recovery Value(%)
                          </MDTypography>
                          <MDInput
                            type="text"
                            name="MaterialRecoveryValue"

                            placeholder="Enter number"
                            fullWidth
                            autoComplete="off"
                            onBlur={formik.handleBlur}
                            onChange={formik.handleChange}
                            value={formik.values.MaterialRecoveryValue}
                            error={
                              formik.touched.MaterialRecoveryValue &&
                              formik.errors.MaterialRecoveryValue &&
                              true
                            }
                            inputProps={{
                              style: {
                                height: "10px",
                              },
                              maxLength: 45,
                            }}
                          />
                          {formik.touched.MaterialRecoveryValue &&
                            formik.errors.MaterialRecoveryValue && (
                              <TextError
                                msg={formik.errors.MaterialRecoveryValue}
                              />
                            )}
                        </MDBox>
                      </Grid>

                      <Grid item xs={12} lg={6}>
                        <MDBox >
                          <MDTypography variant="h6">
                            Reuse Potential(number of cycle)
                          </MDTypography>
                          <MDInput
                            type="number"

                            placeholder="Enter number"
                            name="ReusePotential"
                            fullWidth
                            autoComplete="off"
                            onBlur={formik.handleBlur}
                            onChange={formik.handleChange}
                            value={formik.values.ReusePotential}
                            error={
                              formik.touched.ReusePotential &&
                              formik.errors.ReusePotential &&
                              true
                            }
                            inputProps={{
                              style: {
                                height: "10px",
                              },
                              maxLength: 45,
                            }}
                          />
                          {formik.touched.ReusePotential &&
                            formik.errors.ReusePotential && (
                              <TextError
                                msg={formik.errors.ReusePotential}
                              />
                            )}
                        </MDBox>
                      </Grid>
                      <Grid item xs={12} lg={6}>
                        <MDBox ml={1}>
                          <MDTypography variant="h6">
                            Remark
                          </MDTypography>
                          <MDInput
                            type="text"

                            placeholder="Enter Remarks"
                            name="Remark"
                            fullWidth
                            autoComplete="off"
                            onBlur={formik.handleBlur}
                            onChange={formik.handleChange}
                            value={formik.values.Remark}
                            error={
                              formik.touched.Remark &&
                              formik.errors.Remark &&
                              true
                            }
                            inputProps={{
                              style: {
                                height: "10px",
                              },
                              maxLength: 45,
                            }}
                          />
                          {formik.touched.Remark &&
                            formik.errors.Remark && (
                              <TextError
                                msg={formik.errors.Remark}
                              />
                            )}
                        </MDBox>
                      </Grid>
                      <Grid item xs={12} lg={12}>
                        <MDBox mb={2}>
                          <MDTypography variant="h6">
                            Assessment Date
                          </MDTypography>
                          <MDInput
                            type="date" // Change this from "text" to "date"
                            name="AssesmentDate"
                            fullWidth
                            autoComplete="off"
                            onBlur={formik.handleBlur}
                            onChange={formik.handleChange}
                            value={formik.values.AssesmentDate}
                            error={
                              formik.touched.AssesmentDate &&
                              formik.errors.AssesmentDate &&
                              true
                            }
                            inputProps={{
                              style: {
                                height: "10px",
                              },
                            }}
                          />
                          {formik.touched.AssesmentDate &&
                            formik.errors.AssesmentDate && (
                              <TextError msg={formik.errors.AssesmentDate} />
                            )}
                        </MDBox>
                      </Grid>

                      {/* <Grid item xs={12} lg={6}>
                        <MDBox ml={1}>
                          <MDTypography
                            variant="h6"
                            style={{ fontWeight: "500" }}
                          >
                            {" "}
                            Warehouse Code{" "}
                          </MDTypography>

                          <Select
                            isDisabled={activityIdSelected ? false : true}
                            isClearable
                            className="select-css"
                            maxMenuHeight={130}
                            placeholder="Choose one..."
                            name="warehouseCode"
                            onBlur={() => {
                              formik.handleBlur({
                                target: { name: "warehouseCode" },
                              });
                            }}
                            value={warehouseIdSelected}
                            options={warehouseOptionsByMovement}
                            onChange={(selectedOption) => {
                              handleChangeWarehouse(selectedOption);
                              getZonesByWarehouse(selectedOption?.value);
                              formik.setFieldValue(
                                "warehouseCode",
                                selectedOption
                              );
                              getLevel1ByLevel(
                                selectedOption?.value,
                                0,
                                jwtToken
                              );
                              getLevel2ByLevel(
                                selectedOption?.value,
                                0,
                                jwtToken
                              );
                              getLevel3ByLevel(
                                selectedOption?.value,
                                0,
                                jwtToken
                              );
                              getLevel4ByLevel(
                                selectedOption?.value,
                                0,
                                jwtToken
                              );
                            }}
                          />
                          {formik.touched.warehouseCode &&
                            formik.errors.warehouseCode && (
                              <TextError msg={formik.errors.warehouseCode} />
                            )}
                        </MDBox>
                      </Grid> */}

                      <Grid item xs={12}>
                        <Collapse in={isErrorAllocateItem}>
                          <Alert
                            style={{ marginBottom: "10px" }}
                            severity="error"
                            action={
                              <IconButton
                                aria-label="close"
                                color="inherit"
                                size="small"
                                onClick={() => {
                                  setIsErrorAllocateItem(false);
                                }}
                              >
                                <CloseIcon fontSize="inherit" />
                              </IconButton>
                            }
                          >
                            {errorMsg}
                          </Alert>
                        </Collapse>
                        <Collapse in={isSuccessAllocateItem}>
                          <Alert
                            style={{ marginBottom: "10px" }}
                            severity="success"
                            action={
                              <IconButton
                                aria-label="close"
                                color="inherit"
                                size="small"
                                onClick={() => {
                                  setIsSuccessAllocateItem(false);
                                }}
                              >
                                <CloseIcon fontSize="inherit" />
                              </IconButton>
                            }
                          >
                            Created Successfully
                          </Alert>
                        </Collapse>
                      </Grid>

                      {/* Submit Button */}
                      <MDButton
                        color="info"
                        fullWidth
                        type="submit"
                        disabled={allocateButtonName === "Please wait..."}
                      >
                        {allocateButtonName}
                      </MDButton>
                    </Grid>
                  </MDBox>
                </MDBox>
              </MDCard>
            </Modal>
          </Grid>
        </Grid>
      </MDBox>
      {loading && (
        <Backdrop
          sx={{ color: "blue", zIndex: (theme) => theme.zIndex.drawer + 1 }}
          open
        >
          <CircularProgress color="inherit" />
        </Backdrop>
      )}
      <ToastContainer />
      {/* <Footer /> */}
    </div>
    // </DashboardLayout>
  );
};

const mapStateToProps = (state) => {
  return {
    getSubModulesByRoleIdReducer: state.getSubModulesByRoleIdReducer,
    warehouses: state.warehouses,
    getRepairValueReducer: state.getRepairValueReducer,
    itemMaster: state.itemMaster,
    zonesByWarehouse: state.zonesByWarehouse,
    getLevel1ByLevelReducer: state.getLevel1ByLevelReducer,
    getLevel2ByLevelReducer: state.getLevel2ByLevelReducer,
    getLevel3ByLevelReducer: state.getLevel3ByLevelReducer,
    getLevel4ByLevelReducer: state.getLevel4ByLevelReducer,
    getAcnReducer: state.getAcnReducer,
    openBinsByWarehouse: state.openBinsByWarehouse,
    getRelationLocationReducer: state.getRelationLocationReducer,
    getWarehouseByMovementReducer: state.getWarehouseByMovementReducer,
    levelsByWarehouseReducer: state.levelsByWarehouseReducer,
    getDynamicColumnReducer: state.getDynamicColumnReducer,
    getDPPReducer: state.getDPPReducer,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    getSubModulesByRoleId: (roleId, jwtToken) =>
      dispatch(getSubModulesByRoleId(roleId, jwtToken)),
    getWarehouses: (jwtToken) => dispatch(getWarehouses(jwtToken)),
    getRepairValue: (dppId, jwtToken) => dispatch(getRepairValue(dppId, jwtToken)),
    getItemMaster: (jwtToken) => dispatch(getItemMaster(jwtToken)),
    getZonesByWarehouse: (id, jwtToken) =>
      dispatch(getZonesByWarehouse(id, jwtToken)),
    getLevel1ByLevel: (warehouseId, parentId, jwtToken) =>
      dispatch(getLevel1ByLevel(warehouseId, parentId, jwtToken)),
    getLevel2ByLevel: (warehouseId, parentId, jwtToken) =>
      dispatch(getLevel2ByLevel(warehouseId, parentId, jwtToken)),
    getLevel3ByLevel: (warehouseId, parentId, jwtToken) =>
      dispatch(getLevel3ByLevel(warehouseId, parentId, jwtToken)),
    getLevel4ByLevel: (warehouseId, parentId, jwtToken) =>
      dispatch(getLevel4ByLevel(warehouseId, parentId, jwtToken)),
    getAcn: (jwtToken) => dispatch(getAcn(jwtToken)),
    getOpenBinsByWarehouseAndZone: (id, zoneId, jwtToken) =>
      dispatch(getOpenBinsByWarehouseAndZone(id, zoneId, jwtToken)),
    createRepairValue: (payload, jwtToken) =>
      dispatch(createRepairValue(payload, jwtToken)),
    deleteRepairValue: (rrvId, udBy, jwtToken) =>
      dispatch(deleteRepairValue(rrvId, udBy, jwtToken)),
    uploadForRepairValue: (payload, jwtToken) =>
      dispatch(uploadForRepairValue(payload, jwtToken)),
    getRelationLocation: (jwtToken) => dispatch(getRelationLocation(jwtToken)),
    getWarehousesByMovement: (activityIdSelected, jwtToken) =>
      dispatch(getWarehousesByMovement(activityIdSelected, jwtToken)),
    editRepair: (payload, jwtToken) =>
      dispatch(editRepair(payload, jwtToken)),
    getLevelsByWarehouse: (warehouseId, jwtToken) =>
      dispatch(getLevelsByWarehouse(warehouseId, jwtToken)),
    getDppIds: (jwtToken) =>
      dispatch(getDppIds(jwtToken)),
    getDynamicColumn: (userId, subModuleId, jwtToken) =>
      dispatch(getDynamicColumn(userId, subModuleId, jwtToken)),
    createDynamicColumn: (payload, jwtToken) =>
      dispatch(createDynamicColumn(payload, jwtToken)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(RepairValue);
